import React, { useState } from 'react';
import { Offcanvas } from "react-bootstrap";
import { Stepper } from 'react-form-stepper';
import { Form } from 'react-bootstrap';
import StepOne from './edit/StepOne';
import StepTwo from './edit/StepTwo';
import StepThree from './edit/StepThree';
import StepFour from './edit/StepFour';
import StepFive from './edit/StepFive';
import StepSix from './edit/StepSix';
import StepSeven from './edit/StepSeven';
import StepEight from './edit/StepEight';
import StepNine from './edit/StepNine';
import StepTen from './edit/StepTen';
import { useNavigate } from 'react-router-dom';

const EditDriverDetails = () => {
    const navigation = useNavigate();
   
    const [activeStep, setActiveStep] = useState(0);
    const stepForm = [
        {
            id: 1,
            component: (
                <StepOne activeStep={activeStep} setActiveStep={setActiveStep} />
            ),
        },
        {
            id: 2,
            component: (
                <StepTwo activeStep={activeStep} setActiveStep={setActiveStep} />
            ),
        },
        {
            id: 3,
            component: (
                <StepThree activeStep={activeStep} setActiveStep={setActiveStep} />
            ),
        },
        {
            id: 4,
            component: (
                <StepFour activeStep={activeStep} setActiveStep={setActiveStep} />
            ),
        },
        {
            id: 5,
            component: (
                <StepFive activeStep={activeStep} setActiveStep={setActiveStep} />
            ),
        },
        {
            id: 6,
            component: (
                <StepSix activeStep={activeStep} setActiveStep={setActiveStep} />
            ),
        },
        {
            id: 7,
            component: (
                <StepSeven activeStep={activeStep} setActiveStep={setActiveStep} />
            ),
        },
        {
            id: 8,
            component: (
                <StepEight activeStep={activeStep} setActiveStep={setActiveStep} />
            ),
        },
        {
            id: 9,
            component: (
                <StepNine activeStep={activeStep} setActiveStep={setActiveStep} />
            ),
        },
        {
            id: 10,
            component: (
                <StepTen activeStep={activeStep} setActiveStep={setActiveStep} />
            ),
        },
        // { id: 4, component: <StepOne activeStep={activeStep} /> },
    ];
    return (
        <>
            <div className="canvas-lg bg-light py-5" placement="end">

                <div className="top-bar text-center">
                    <Offcanvas.Title>
                        Driver Application
                    </Offcanvas.Title>
                </div>

                <Offcanvas.Body>
                    <Stepper
                        steps={[{ label: ''},{ label: ''},{ label: ''},{ label: ''},{ label: ''},{ label: ''},{ label: ''},{ label: ''},{ label: ''},{ label: ''}]}
                        styleConfig={{
                            activeBgColor: "rgba(45, 51, 61, 0.6)",
                            activeTextColor: "#fff",
                            inactiveBgColor: "#fff",
                            inactiveTextColor: "#999",
                            completedBgColor: "rgb(45, 51, 61)",
                            completedTextColor: "#fff",
                            size: "2em",
                        }}
                        activeStep={activeStep + 1}
                    />
                    {stepForm[activeStep].component}
                  
                </Offcanvas.Body>
            </div>
        </>
    );
};

export default EditDriverDetails;